(function() {
  var previousCleanup = window.__yxFooterCleanup;
  if (typeof previousCleanup === 'function') previousCleanup();

  var listenerCleanups = [];

  function listen(target, type, handler, options) {
    target.addEventListener(type, handler, options);
    listenerCleanups.push(function() {
      target.removeEventListener(type, handler, options);
    });
  }

  function cleanup() {
    listenerCleanups.splice(0).forEach(function(removeListener) {
      removeListener();
    });
    if (window.__yxFooterCleanup === cleanup) delete window.__yxFooterCleanup;
  }

  window.__yxFooterCleanup = cleanup;

  var newsletterDismissedStorageKey = 'yx-newsletter-dismissed-v1';
  var localConsentStorageKey = 'yx-cookie-consent-v1';
  var signupDismissedThisPage = false;

  function readStoredLocalConsent() {
    try {
      return JSON.parse(window.localStorage.getItem(localConsentStorageKey));
    } catch (_error) {
      return null;
    }
  }

  function preferencesAreAllowed(consent) {
    var currentConsent = consent;
    var isLocalhost = window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost';
    if (!currentConsent && isLocalhost) {
      currentConsent = readStoredLocalConsent();
    }
    if (!currentConsent) {
      currentConsent = window.Shopify && window.Shopify.customerPrivacy &&
        window.Shopify.customerPrivacy.currentVisitorConsent &&
        window.Shopify.customerPrivacy.currentVisitorConsent();
    }
    return Boolean(currentConsent && (currentConsent.preferences === true || currentConsent.preferences === 'yes'));
  }

  function storeNewsletterDismissal() {
    try {
      window.localStorage.setItem(newsletterDismissedStorageKey, '1');
    } catch (_error) {
      // Keep the current page dismissed if storage is unavailable.
    }
  }

  function clearNewsletterDismissal() {
    try {
      window.localStorage.removeItem(newsletterDismissedStorageKey);
    } catch (_error) {
      // No action is needed when storage is unavailable.
    }
  }

  function newsletterWasDismissed() {
    if (!preferencesAreAllowed()) return false;
    try {
      return window.localStorage.getItem(newsletterDismissedStorageKey) === '1';
    } catch (_error) {
      return false;
    }
  }

  function hideSignup(signup, remember) {
    if (!signup) return;
    signup.hidden = true;
    if (!remember) return;
    signupDismissedThisPage = true;
    if (preferencesAreAllowed()) storeNewsletterDismissal();
  }

  if (newsletterWasDismissed()) {
    document.querySelectorAll('.yx-site-footer__signup').forEach(function(signup) {
      hideSignup(signup, false);
    });
  }

  listen(document, 'yx:cookie-consent-updated', function(event) {
    if (preferencesAreAllowed(event.detail)) {
      if (signupDismissedThisPage) storeNewsletterDismissal();
    } else {
      clearNewsletterDismissal();
    }
  });

  function scrollToTop() {
    var doc = document.documentElement;
    var body = document.body;
    var docScrollBehavior = doc.style.scrollBehavior;
    var bodyScrollBehavior = body.style.scrollBehavior;

    doc.style.scrollBehavior = 'auto';
    body.style.scrollBehavior = 'auto';
    window.scrollTo(0, 0);
    doc.scrollTop = 0;
    body.scrollTop = 0;

    window.requestAnimationFrame(function() {
      window.scrollTo(0, 0);
      doc.scrollTop = 0;
      body.scrollTop = 0;
    });

    window.setTimeout(function() {
      window.scrollTo(0, 0);
      doc.scrollTop = 0;
      body.scrollTop = 0;
      doc.style.scrollBehavior = docScrollBehavior;
      body.style.scrollBehavior = bodyScrollBehavior;
    }, 150);
  }

  function initBacktop() {
    var footer = document.querySelector('[data-yx-site-footer]');
    var backtop = footer && footer.querySelector('.yx-site-footer__backtop');
    var hero = document.querySelector('.yx-home__hero');
    var pageType = footer && footer.getAttribute('data-yx-page-type');
    var isMobileViewport = window.matchMedia('(max-width: 749px)').matches;
    var isTabletViewport = window.matchMedia('(min-width: 750px) and (max-width: 1199px)').matches;
    var isDesktopExcludedRoute = !isMobileViewport && !isTabletViewport && (pageType === 'cart' || pageType === 'search');
    if (!backtop || isDesktopExcludedRoute) return;
    var backtopFrame = 0;

    function syncBacktopVisibility() {
      backtopFrame = 0;
      var scrollTop = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
      var isVisible = hero
        ? hero.getBoundingClientRect().bottom <= 0
        : scrollTop >= window.innerHeight;
      if (backtop.hasAttribute('data-yx-backtop-visible') !== isVisible) backtop.toggleAttribute('data-yx-backtop-visible', isVisible);
      if (backtop.getAttribute('aria-hidden') !== String(!isVisible)) backtop.setAttribute('aria-hidden', String(!isVisible));
      if (isVisible) {
        if (backtop.hasAttribute('tabindex')) backtop.removeAttribute('tabindex');
      } else if (backtop.getAttribute('tabindex') !== '-1') backtop.setAttribute('tabindex', '-1');
    }

    function scheduleBacktopVisibility() {
      if (!backtopFrame) backtopFrame = window.requestAnimationFrame(syncBacktopVisibility);
    }

    backtop.setAttribute('data-yx-backtop-fixed', '');
    syncBacktopVisibility();
    listen(window, 'scroll', scheduleBacktopVisibility, { passive: true });
    listen(window, 'resize', scheduleBacktopVisibility, { passive: true });
    listenerCleanups.push(function() {
      window.cancelAnimationFrame(backtopFrame);
    });
  }

  initBacktop();

  function initTrustpilotPlacement() {
    var footer = document.querySelector('[data-yx-site-footer]');
    var proof = footer && footer.querySelector('.yx-site-footer__proof');
    var trustbox = proof && proof.querySelector('[data-yx-trustbox]');
    var desktopSlot = footer && footer.querySelector('[data-yx-trustbox-desktop-slot]');
    if (!proof || !trustbox || !desktopSlot) return;

    function syncTrustpilotPlacement() {
      var target = window.matchMedia('(min-width: 1200px)').matches ? desktopSlot : proof;
      if (trustbox.parentElement !== target) target.appendChild(trustbox);
    }

    syncTrustpilotPlacement();
    listen(window, 'resize', syncTrustpilotPlacement, { passive: true });
  }

  initTrustpilotPlacement();

  function initChatClearance() {
    var chat = null;
    var activator = null;
    var launcher = null;
    var originalMargin = '';
    var frame = 0;
    var gap = 10;
    var relevantSelector = 'shopify-chat, [data-yx-site-footer], .yx-home__hero';
    var observedFooter = null;
    var footerInViewport = true;
    var resizeObserver = new ResizeObserver(schedule);
    var shadowObserver = new MutationObserver(schedule);
    var intersectionObserver = typeof IntersectionObserver === 'function' ? new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.target === observedFooter) footerInViewport = entry.isIntersecting;
      });
      schedule();
    }) : null;

    function sync() {
      frame = 0;
      var footer = document.querySelector('[data-yx-site-footer]');
      if (intersectionObserver && footer !== observedFooter) {
        if (observedFooter) intersectionObserver.unobserve(observedFooter);
        observedFooter = footer;
        footerInViewport = Boolean(footer);
        if (footer) intersectionObserver.observe(footer);
      }
      var nextChat = document.querySelector('shopify-chat');
      var chatRoot = nextChat && nextChat.shadowRoot;
      var runtime = chatRoot && chatRoot.querySelector('shopify-agent-runtime');
      var launcherRoot = runtime && runtime.shadowRoot || chatRoot;
      var nextActivator = launcherRoot && launcherRoot.querySelector('[part~="activator"]');
      if (!nextActivator) return;
      var nextLauncher = nextActivator.parentElement;
      if (window.getComputedStyle(nextLauncher).position !== 'absolute') return;
      if (activator !== nextActivator || launcher !== nextLauncher) {
        if (launcher) launcher.style.marginBottom = originalMargin;
        resizeObserver.disconnect();
        shadowObserver.disconnect();
        chat = nextChat;
        activator = nextActivator;
        launcher = nextLauncher;
        originalMargin = launcher.style.marginBottom;
        shadowObserver.observe(chat.shadowRoot, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-expanded', 'hidden', 'class'] });
        if (launcherRoot !== chat.shadowRoot) {
          shadowObserver.observe(launcherRoot, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-expanded', 'hidden', 'class'] });
        }
        resizeObserver.observe(activator);
        resizeObserver.observe(document.body);
        if (footer) resizeObserver.observe(footer);
        var hero = document.querySelector('.yx-home__hero');
        if (hero) resizeObserver.observe(hero);
      }
      if (launcher.style.marginBottom !== 'var(--yx-chat-launcher-lift, 0px)') {
        launcher.style.marginBottom = 'var(--yx-chat-launcher-lift, 0px)';
      }
      var rect = activator.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      // Move the measured launcher container, including its pointer hit area.
      var previousLift = parseFloat(chat.style.getPropertyValue('--yx-chat-launcher-lift')) || 0;
      var bottom = rect.bottom + previousLift;
      var lift = 0;
      var obstacles = [];
      // The back-to-top button is fixed and remains an obstacle even when
      // the footer is below the viewport. Other footer controls need geometry
      // only while the footer is visible; its observer schedules entry/exit.
      var obstacleSelector = '.yx-site-footer__backtop[data-yx-backtop-visible]';
      if (footerInViewport || !footer || footer.getAttribute('data-yx-page-type') !== 'index') {
        obstacleSelector += ', .yx-site-footer__social a, .yx-site-footer__payments > *, .yx-site-footer__claim';
      }
      document.querySelectorAll(obstacleSelector).forEach(function(control) {
        var box = control.getBoundingClientRect();
        var style = window.getComputedStyle(control);
        if (!box.width || !box.height || box.bottom <= 0 || box.top >= window.innerHeight ||
            style.visibility === 'hidden' || style.display === 'none' || style.pointerEvents === 'none') return;
        if (box.left < rect.right + gap && box.right > rect.left - gap) obstacles.push(box);
      });
      obstacles.sort(function(a, b) { return b.top - a.top; });
      obstacles.forEach(function(box) {
        var candidateBottom = bottom - lift;
        var candidateTop = candidateBottom - rect.height;
        if (candidateBottom > box.top - gap && candidateTop < box.bottom + gap) {
          lift = Math.max(lift, bottom - box.top + gap);
        }
      });
      var value = Math.ceil(lift) + 'px';
      if (chat.style.getPropertyValue('--yx-chat-launcher-lift') !== value) {
        chat.style.setProperty('--yx-chat-launcher-lift', value);
      }
    }

    function schedule() {
      if (!frame) frame = window.requestAnimationFrame(sync);
    }

    function containsRelevantElement(node) {
      return node instanceof Element && (
        node.matches(relevantSelector + ', style, link[rel="stylesheet"]') ||
        node.querySelector(relevantSelector + ', style, link[rel="stylesheet"]')
      );
    }

    var observer = new MutationObserver(function(records) {
      if (!chat || !chat.isConnected || !activator || !activator.isConnected || footerInViewport) {
        schedule();
        return;
      }
      if (records.some(function(record) {
        return (record.target instanceof Element && record.target.closest(relevantSelector)) ||
          Array.prototype.some.call(record.addedNodes, containsRelevantElement) ||
          Array.prototype.some.call(record.removedNodes, containsRelevantElement);
      })) schedule();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    listen(window, 'scroll', schedule, { passive: true });
    listen(window, 'resize', schedule, { passive: true });
    listen(window, 'load', schedule);
    listen(document, 'transitionend', schedule, true);
    listenerCleanups.push(function() {
      observer.disconnect();
      resizeObserver.disconnect();
      shadowObserver.disconnect();
      if (intersectionObserver) intersectionObserver.disconnect();
      window.cancelAnimationFrame(frame);
      if (launcher) launcher.style.marginBottom = originalMargin;
      if (chat) chat.style.removeProperty('--yx-chat-launcher-lift');
    });
    schedule();
  }

  initChatClearance();

  function isServiceSwipeViewport() {
    return window.matchMedia('(max-width: 749px), (min-width: 990px) and (max-width: 1199px)').matches;
  }

  function rotateServiceItem(serviceRoot, direction) {
    var items = serviceRoot ? Array.prototype.slice.call(serviceRoot.querySelectorAll('[data-yx-service-item]')) : [];
    if (!items.length) return false;

    var activeIndex = items.findIndex(function(item) {
      return item.hasAttribute('data-yx-active');
    });
    if (activeIndex < 0) activeIndex = 0;

    var nextIndex = (activeIndex + direction + items.length) % items.length;
    items.forEach(function(item, index) {
      if (index === nextIndex) item.setAttribute('data-yx-active', '');
      else item.removeAttribute('data-yx-active');
    });
    return true;
  }

  function initServiceSwipe() {
    document.querySelectorAll('[data-yx-service-strip], [data-yx-home-service-strip]').forEach(function(serviceRoot) {
      var startX = 0;
      var startY = 0;
      var tracking = false;

      listen(serviceRoot, 'touchstart', function(event) {
        if (!isServiceSwipeViewport() || event.touches.length !== 1) return;
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
        tracking = true;
      }, { passive: true });

      listen(serviceRoot, 'touchend', function(event) {
        if (!tracking || !isServiceSwipeViewport() || event.changedTouches.length !== 1) return;
        tracking = false;

        var deltaX = event.changedTouches[0].clientX - startX;
        var deltaY = event.changedTouches[0].clientY - startY;
        if (Math.abs(deltaX) < 40 || Math.abs(deltaX) <= Math.abs(deltaY)) return;

        if (rotateServiceItem(serviceRoot, deltaX < 0 ? 1 : -1)) {
          serviceRoot.dataset.yxServiceSwipedAt = String(Date.now());
        }
      }, { passive: true });
    });
  }

  initServiceSwipe();

  function findVisibleFooterEmail() {
    return Array.prototype.find.call(
      document.querySelectorAll('.yx-site-footer__newsletter input[type="email"]'),
      function(input) {
        var rect = input.getBoundingClientRect();
        var style = window.getComputedStyle(input);
        return rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden';
      }
    );
  }

  function focusFooterEmail(footerInput) {
    /* Focus first so desktop browsers immediately reveal the destination;
       the follow-up smooth scroll only refines its final position. */
    footerInput.focus();
    footerInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  /* Keep direct newsletter controls available if another footer interaction
     stops propagation. Stop their own event so delegated handling below does
     not repeat the same close or focus action. */
  document.querySelectorAll('[data-yx-signup-close]').forEach(function(close) {
    listen(close, 'click', function(event) {
      event.preventDefault();
      event.stopPropagation();
      var signup = close.closest('.yx-site-footer__signup');
      hideSignup(signup, true);
    });
  });

  document.querySelectorAll('[data-yx-signup-cta]').forEach(function(cta) {
    listen(cta, 'click', function(event) {
      var signup = cta.closest('.yx-site-footer__signup');
      var signupInput = signup && signup.querySelector('input[type="email"]');
      var inputIsHidden = signupInput && (signupInput.offsetParent === null || signupInput.getClientRects().length === 0);
      var footerInput = inputIsHidden && findVisibleFooterEmail();
      if (!footerInput) return;
      event.preventDefault();
      event.stopPropagation();
      focusFooterEmail(footerInput);
    });
  });

  listen(document, 'click', function(event) {
    var footerHeading = event.target.closest('.yx-site-footer__nav-heading');
    if (footerHeading) {
      var footerNav = footerHeading.closest('nav');
      if (footerNav) {
        var isOpen = footerNav.hasAttribute('data-yx-footer-nav-open');
        if (isOpen) {
          footerNav.removeAttribute('data-yx-footer-nav-open');
          footerHeading.setAttribute('aria-expanded', 'false');
        } else {
          footerNav.setAttribute('data-yx-footer-nav-open', '');
          footerHeading.setAttribute('aria-expanded', 'true');
        }
      }
      return;
    }

    var backtop = event.target.closest('.yx-site-footer__backtop');
    if (backtop) {
      event.preventDefault();
      scrollToTop();
      if (window.history && window.history.replaceState) {
        window.history.replaceState({}, '', window.location.pathname + window.location.search);
      }
      return;
    }

    var signupClose = event.target.closest('[data-yx-signup-close]');
    if (signupClose) {
      var signup = signupClose.closest('.yx-site-footer__signup');
      if (signup) {
        event.preventDefault();
        hideSignup(signup, true);
      }
      return;
    }

    var signupCta = event.target.closest('[data-yx-signup-cta]');
    if (signupCta) {
      var signupRoot = signupCta.closest('.yx-site-footer__signup');
      var signupInput = signupRoot && signupRoot.querySelector('input[type="email"]');
      var inputIsHidden = signupInput && (signupInput.offsetParent === null || signupInput.getClientRects().length === 0);
      if (inputIsHidden) {
        var footerInput = findVisibleFooterEmail();
        if (footerInput) {
          event.preventDefault();
          focusFooterEmail(footerInput);
          return;
        }
      }
    }

    var serviceButton = event.target.closest('[data-yx-service-prev], [data-yx-service-next]');
    if (!serviceButton) return;

    var serviceRoot = serviceButton.closest('[data-yx-service-strip], [data-yx-home-service-strip]');
    var swipedAt = Number(serviceRoot && serviceRoot.dataset.yxServiceSwipedAt) || 0;
    if (Date.now() - swipedAt < 400) {
      event.preventDefault();
      return;
    }

    rotateServiceItem(serviceRoot, serviceButton.hasAttribute('data-yx-service-prev') ? -1 : 1);
  });

  listen(document, 'keydown', function(event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var footerHeading = event.target.closest('.yx-site-footer__nav-heading');
    if (!footerHeading) return;
    event.preventDefault();
    footerHeading.click();
  });
})();
